import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SPINE = [
  ["date_of_service", "Date of service (Stage 1)"],
  ["doc_upload_date", "Documents uploaded (Stage 2 — 72h)"],
  ["alteva_handoff_date", "Alteva handoff (Stage 4-5)"],
  ["carrier_submission_date", "Carrier submission (Stage 7)"],
  ["carrier_determination_date", "Carrier determination / allowable (Stage 8)"],
  ["idr_entry_date", "IDR entry (Stage 9)"],
  ["idr_determination_date", "IDR determination (Stage 11)"],
  ["payment_received_date", "Payment posted (Stage 12)"],
];

export default function CaseTimeline({ active, show }) {
  const [data, setData] = useState(null);
  const [sel, setSel] = useState("");
  const load = useCallback(() => {
    axios.get(`${API}/masterfile/current`).then((r) => setData(r.data)).catch(() => {});
  }, []);
  useEffect(() => { if (active === "ctl") load(); }, [active, load]);

  const empty = !data || data.empty;
  const cases = data?.cases || [];
  const c = cases.find((x) => x.case_id === sel) || cases[0];

  return (
    <section className={`chapter utility${active === "ctl" ? " active" : ""}`} id="ctl">
      <div className="eyebrow">Read-only computed view · source: monthly master case file stage dates</div>
      <h1>Case Timeline</h1>
      {!empty && <div className="vr-pill open" style={{ marginBottom: 10 }}>DATA AS OF {data.as_of} — monthly master file</div>}
      <p className="lede">One case at a time, plotted along the 12-stage lifecycle spine. Dates the case hasn't reached render as "not reached" — a young case is young, not stalled. Out-of-order dates carry a data-quality flag, consistent with the upload validation's stage-regression check. Per-stage aging medians on the KPI dashboard come from this same computation — one code path, so the two views can never disagree.</p>

      {empty ? (
        <div className="formcard" data-testid="ctl-empty">No data — upload monthly master file. <button className="vr-link" onClick={() => show("mcf")}>Go to Monthly Case File →</button></div>
      ) : (
        <>
          <div className="month-bar">
            <label>Case</label>
            <select className="inp" style={{ maxWidth: 280 }} value={c?.case_id || ""} onChange={(e) => setSel(e.target.value)} data-testid="ctl-case-select">
              {cases.map((x) => <option key={x.case_id} value={x.case_id}>{x.case_id} — stage {x.current_stage || "?"}</option>)}
            </select>
          </div>
          {c && (
            <div className="formcard" data-testid="ctl-timeline">
              <div className="formcard-title">{c.case_id} · {c.surgical_assist || "—"} · {c.payer || "—"} · stage {c.current_stage || "?"} of 12
                {c.exceptions.some((e) => e.startsWith("DATA QUALITY")) && <span className="vr-pill declined" style={{ marginLeft: 8 }}>DATA-QUALITY FLAG: out-of-order stage dates</span>}
              </div>
              <table className="mform-table"><tbody>
                <tr><th>Milestone</th><th style={{ width: 140 }}>Date</th><th style={{ width: 120 }}>Gap</th></tr>
                {SPINE.map(([k, label], i) => {
                  const prev = SPINE.slice(0, i).map(([pk]) => c[pk]).filter(Boolean).pop();
                  const gap = c[k] && prev ? Math.round((new Date(c[k]) - new Date(prev)) / 86400000) : null;
                  return (
                    <tr key={k}>
                      <td>{label}</td>
                      <td>{c[k] || <span style={{ color: "var(--mute)" }}>not reached</span>}</td>
                      <td>{gap != null ? `${gap}d${gap < 0 ? " ⚠ out of order" : ""}` : "—"}</td>
                    </tr>
                  );
                })}
              </tbody></table>
              {(c.missed_windows.length > 0 || c.aging_flags.length > 0) && (
                <p className="k-sub" style={{ marginTop: 8 }}>
                  {c.missed_windows.map((w, i) => <span key={i} className="vr-pill declined" style={{ marginRight: 6 }}>MISSED: {w}</span>)}
                  {c.aging_flags.map((f, i) => <span key={i} className="vr-pill open" style={{ marginRight: 6 }}>{f}</span>)}
                </p>
              )}
            </div>
          )}
        </>
      )}
    </section>
  );
}
